// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"7186c7c4","334":"ac346e97","365":"26a61711","453":"30041485","688":"d57421a5","722":"40718b7d"}[chunkId] + ".chunk.js";
};